import React from 'react';
import styled from 'styled-components';

const CaptionContainer = styled.div`
        font-family: 'Noto Sans KR', sans-serif;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.79;
        letter-spacing: normal;
        text-align: left;
        color: #494949;
        margin-bottom: 16px;
    `;
    
function Caption({ children }) {
    return (
        <CaptionContainer>
            {children}
        </CaptionContainer>
    );
}

export default Caption;